import React, {useEffect, useState} from "react";
import './ExperienceList.scss';

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import {useNavigate} from "react-router-dom";
import TicketComponent from "../../components/Card/Ticket/TicketComponent";
import Alert from "react-bootstrap/Alert";

let img_top = require("../../assets/Experience.jpg");

function ExperienceList() {
    const navigate = useNavigate();

    const [tickets, setTickets] = useState([]);

    useEffect(() => {
        document.title = "Geoticket - Esperienze";
    }, []);

    useEffect(() => {
        fetch(global.route.listExperience, {
            method: "post",
            credentials: 'include',
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(response => {
                        setTickets(response.list);
                    });
                }
            });
    }, []);

    let getTickets = () => {
        if (Object.keys(tickets).length === 0)
            return (<div className={"container"}><Alert variant={"warning"}>Non ci sono ticket disponibili in questa
                sezione</Alert></div>)
        let result = [];
        for (let ticket of tickets) {
            result.push(<div className={"col-lg-4 col-md-6 pt-2 pb-2"}>
                <TicketComponent ticket={ticket} showArea={true}
                                 onClick={(withAdvantges) => navigate("/event/" + ticket.id + (withAdvantges ? "?advantages=true" : ""))}/>
            </div>)
        }
        return result;
    }

    return (<div style={{backgroundColor: "#fafafa"}} className={"area-info"}>
        <Header/>
        <div className="video-section">
            <img className="background-video" src={img_top}/>
            <div className="overlay-content background">
                <div>
                    <div className={"container"}>
                        <div style={{flex: 1}}>
                            <h1 className="title">Regala o prenota le migliori esperienze all’aperto</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style={{backgroundColor: "#EEEEEE"}}>
            <div className="container pt-4 pb-4">
                <div className="row">
                    {getTickets()}
                </div>
            </div>
        </div>
        <Footer/>
    </div>);
}

export default ExperienceList;